import "./editorialForms.css";

const platforms = [
  { id: "pc", name: "PC" },
  { id: "playstation", name: "PlayStation" },
  { id: "xbox", name: "Xbox" },
  { id: "nintendo", name: "Nintendo" },
  { id: "mobile", name: "Mobile" },
  { id: "multi", name: "Multiplataforma" },
];

const streamTypes = [
  { id: "live", name: "Live/Stream" },
  { id: "clip", name: "Clip" },
  { id: "highlight", name: "Highlight" },
  { id: "vod", name: "VOD" },
];

const categories = [
  { id: "fps", name: "FPS/Shooter" },
  { id: "rpg", name: "RPG" },
  { id: "moba", name: "MOBA" },
  { id: "sports", name: "Esportes" },
  { id: "racing", name: "Corrida" },
  { id: "puzzle", name: "Puzzle" },
  { id: "simulation", name: "Simulação" },
  { id: "fighting", name: "Luta" },
  { id: "battle_royale", name: "Battle Royale" },
  { id: "adventure", name: "Aventura" },
];

export default function GamingForm({ data, onChange }) {
  return (
    <div className="editorial_form gaming_form">
      <div className="editorial_form_section">
        <label>Nome do Jogo</label>
        <input
          type="text"
          placeholder="Ex: Valorant, FIFA 24, GTA V"
          value={data?.game || ""}
          onChange={(e) => onChange({ ...data, game: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Plataforma</label>
          <select
            value={data?.platform || ""}
            onChange={(e) => onChange({ ...data, platform: e.target.value })}
          >
            <option value="">Selecione</option>
            {platforms.map((platform) => (
              <option key={platform.id} value={platform.id}>
                {platform.name}
              </option>
            ))}
          </select>
        </div>
        <div className="editorial_form_section">
          <label>Tipo de Conteúdo</label>
          <select
            value={data?.streamType || ""}
            onChange={(e) => onChange({ ...data, streamType: e.target.value })}
          >
            <option value="">Selecione</option>
            {streamTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione a categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isEsports"
            checked={data?.isEsports || false}
            onChange={(e) => onChange({ ...data, isEsports: e.target.checked })}
          />
          <label htmlFor="isEsports">Conteúdo de eSports</label>
        </div>
      </div>

      <div className="editorial_form_tip gaming_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
        </svg>
        <span>Faça upload do vídeo ou clip usando o botão de mídia</span>
      </div>
    </div>
  );
}
